<template>
  <CrewSection :crew="crew" kicker="The People Across the Years" trip-label="re:Invent" />
</template>

<script>
import CrewSection from '../people/CrewSection.vue';

export default {
  name: 'RecurringCrewGrid',
  components: { CrewSection },
  props: { crew: { type: Array, default: () => [] } },
};
</script>
